import backend from 'utils/backend'

export const SET_GRANTFIT_ERROR = 'SET_GRANTFIT_ERROR'
export const SET_GRANTFIT_SUMMARIES_LOADING = 'SET_GRANTFIT_SUMMARIES_LOADING'
export const SET_GRANTFIT_SUMMARIES = 'SET_GRANTFIT_SUMMARIES'
export const UPDATE_GRANTFIT_SUMMARY = 'UPDATE_GRANTFIT_SUMMARY'

export const clearGrantFitError = async (dispatch, getState) => {
  const {
    grantfit: { error }
  } = getState()
  if (error) dispatch({ type: SET_GRANTFIT_ERROR, payload: { error: null } })
}

export const setGrantFitSummariesLoading = newLoadingState => async dispatch => {
  dispatch({ type: SET_GRANTFIT_SUMMARIES_LOADING, payload: { isLoading: newLoadingState } })
}

export const getGrantFitSummariesForFunder =
  (funderId, setLoadingState = true) =>
  async dispatch => {
    dispatch(clearGrantFitError)

    if (setLoadingState) dispatch(setGrantFitSummariesLoading(true))

    try {
      const { data } = await backend.get(`api/grantfit/?funder=${funderId}`)
      if (data.results) {
        dispatch({ type: SET_GRANTFIT_SUMMARIES, payload: { summaries: data.results } })
      }
    } catch (err) {
      dispatch({ type: SET_GRANTFIT_ERROR, payload: { error: 'getSummariesFailed' } })
    }
    dispatch(setGrantFitSummariesLoading(false))
  }

const TIMEOUT_THRESHOLD = 3 * 60 * 1000 // 3 minutes
const PROCESSING_STATUSES = ['pending', 'processing']
const COMPLETED_STATUSES = ['completed', 'error']

export const updateGrantFitSummaryStatus = summaryId => async (dispatch, getState) => {
  dispatch(clearGrantFitError)

  const {
    grantfit: { summaries }
  } = getState()
  const summary = summaries.find(s => s.id === summaryId)

  try {
    const { data } = await backend.get(`api/grantfit/${summaryId}/`)

    const elapsed = new Date() - summary.requestSentAt
    const timedOut = elapsed >= TIMEOUT_THRESHOLD && !COMPLETED_STATUSES.includes(data.status)

    const isProcessing = !timedOut && PROCESSING_STATUSES.includes(data.status)

    if (isProcessing) {
      setTimeout(() => dispatch(updateGrantFitSummaryStatus(summaryId)), 5000)
    } else {
      dispatch({
        type: UPDATE_GRANTFIT_SUMMARY,
        payload: { summary: { ...data, isProcessing, timedOut } }
      })
    }
  } catch (err) {
    dispatch({ type: SET_GRANTFIT_ERROR, payload: { error: 'updateStatusFailed' } })
  }
}

export const runGrantFitAnalysis =
  ({ funderId, programId, applicantText, files, documents }) =>
  async dispatch => {
    dispatch(clearGrantFitError)

    const formdata = new FormData()
    formdata.append('funder', funderId)
    if (programId) formdata.append('program', programId)
    if (applicantText) formdata.append('applicantText', applicantText)
    if (files) {
      for (const file of files) {
        formdata.append('files', file.file)
      }
    }
    if (documents) {
      for (const document of documents) {
        formdata.append('documents', document.id)
      }
    }

    try {
      const { data } = await backend.post('api/grantfit/', formdata, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      dispatch({
        type: UPDATE_GRANTFIT_SUMMARY,
        payload: {
          summary: { ...data, isProcessing: true, requestSentAt: new Date() }
        }
      })
      setTimeout(() => dispatch(updateGrantFitSummaryStatus(data.id), 1000))
    } catch (err) {
      dispatch({ type: SET_GRANTFIT_ERROR, payload: { error: 'runAnalysisFailed' } })
    }
  }
